import React from 'react';

import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';

import {
  SkypassFooterNoticeContainer,
  SkypassFooterSubNoticeContainer,
  StyledFooterNoticeTextBox,
  TextBold,
} from '@ecp/fo/sites/skypass/styles/footer/SkypassFooterBottomStyles';

export default function SkypassFooterNotice() {
  return (
    <SkypassFooterNoticeContainer>
      <Spacing top={'36px'} />
      <TextBox size={'28px'} weight={'500'} height={'45px'}>
        알아두세요
      </TextBox>
      <Spacing top={'8px'} />
      <SkypassFooterSubNoticeContainer>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>대한항공 홈페이지 회원 가입 및 로그인 후 이용 가능합니다.
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>본인의 보유 마일리지만 사용할 수 있으며, 가족합산은 불가합니다.
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>상품 구매취소나 환불 시, 유효기간이 지난 마일리지는 소멸되어 환급되지 않습니다.
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>자세한 내용은 상품 상세 페이지를 참고해주세요.
        </StyledFooterNoticeTextBox>
      </SkypassFooterSubNoticeContainer>
    </SkypassFooterNoticeContainer>
  );
}
